/**
 * https://github.kakaocorp.com/kakaopage/api/blob/26cf2794f8edff06f41dffc6d543e35819980b05/api/src/main/java/com/kakaopage/api/model/enums/RedeemCodeType.java
 */

export enum RedeemCodeTypeVo {
  /**
   * API코드에서 Case인 경우 실제 type은 credit으로 내려주고 있습니다.
   */
  Credit = 'credit',
  /**
   뽑기권 리딤코드, 뽑기권 화면에 접근을 위한 리딤코드
   */
  Gacha = 'gacha',
  None = 'none',
  Point = 'point',
  Ticket = 'ticket',
  /**
   이용권 리딤코드의 경우 type이 RT나 TT로 내려오는 경우가 존재합니다.
   */
  TicketRent = 'RT04',
  TicketBuy = 'TT04',
}
